import { render } from "./ITServices.vue?vue&type=template&id=04836c5a"
import script from "./ITServices.vue?vue&type=script&lang=js"
export * from "./ITServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__